'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Link } from 'atoms/Link/Link';
import { gtmPushBurgerMenuMobileLevel } from 'modules/gtm/modules/sections/navigation/navigation';
import { INavigationItemProps } from './types';
import styles from './SidebarNavigation.module.css';

export const NavigationItem: FC<INavigationItemProps> = ({
  onClick,
  className,
  breadcrumbs = [],
  hasChildren,
  title,
  url,
  backgroundColor,
}) => {
  const pushGtmEvent = () => {
    gtmPushBurgerMenuMobileLevel([...breadcrumbs, title]);
  };

  const handleClick = () => {
    onClick?.();
    pushGtmEvent();
  };

  if (hasChildren) {
    return (
      <div onClick={handleClick} className={clsx(styles.navItem, className)}>
        <span
          style={{
            color: backgroundColor,
          }}
        >
          {title}
        </span>
        <Icon type={IconType.arrowDown} className={clsx(styles.iconForward)} />
      </div>
    );
  }

  if (!!url) {
    const correctUrl = url.startsWith('/') ? url : `/${url}`;

    return (
      <Link
        href={correctUrl}
        className={clsx(styles.navItem, className)}
        onClick={pushGtmEvent}
      >
        <span
          style={{
            color: backgroundColor,
          }}
        >
          {title}
        </span>
      </Link>
    );
  }

  return null;
};
